import CompensationList from 'components/elements/compensation/CompensationList'
import RequestTemplate from 'components/templates/RequestTemplate'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'
import { PAGE_PATH } from 'constants/pagePath'
import { EditingItemContext } from 'contexts/EditingItemContext'
import React, { useCallback, useContext } from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { createProps } from 'utils/commonUtils'
import { getDomain , isKsDomain, isSaficDomain} from 'utils/domain'
import { StatusProps } from 'utils/status'
import { useProgressPoint } from '../../utils/commonHooks'

/**
 * RAK006: 補償画面(燃料切れ以外)
 */
const ServiceOtherEmptyFuel: React.FC<StatesProps> = (props: QnStatesProps) => {
  const [editingItem] = useContext(EditingItemContext)
  const { state, setState } = createProps(props, editingItem)
  const forwardAction = useCallback((): StatusProps => {
    return setState({ ...state })
  }, [state])

  const compensationItems = isKsDomain() ? CLIENT_SETTINGS.messages.compensation[state.productKbnCd] :isSaficDomain() ? CLIENT_SETTINGS.messages.compensation.normal : {
    [DOMAIN.SJ]: CLIENT_SETTINGS.messages.compensation[state.productKbnCd],
  }[getDomain()]

  const description = isSaficDomain() ? '以下の対応や費用について、ご確認ください。' : ''

  const forwardLabel = isKsDomain() ? '次へ' : isSaficDomain() ? '確認画面へ' :{
    [DOMAIN.SJ]: '次へ',
  }[getDomain()]

  return (
    <RequestTemplate
      title={'補償内容について'}
      showContact
      progress={useProgressPoint()}
      description={description}
      content={<CompensationList items={compensationItems} />}
      forwardTo={PAGE_PATH.CONFIRMATION}
      forwardAction={forwardAction}
      forwardLabel={forwardLabel}
      showBack
      notClearEditingItem
    />
  )
}
export default ServiceOtherEmptyFuel
